import { render, staticRenderFns } from "./ProviderSettings.vue?vue&type=template&id=305df612&"
import script from "./ProviderSettings.vue?vue&type=script&lang=js&"
export * from "./ProviderSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProviderSettings.vue"
export default component.exports